module.exports = __webpack_public_path__ + "img/41.3d5cc1b3.svg";